export enum RepairBumperPaymentTypeEnum {
  'NA' = 'NA',
  'PerHour' = 'PerHour',
  'PerBoard' = 'PerBoard',
  'Percentage' = 'Percentage',
}
